const getAllAlertsData = state => state.alert;

export default getAllAlertsData;